import React, {useMemo} from 'react'
import {withRouter} from "react-router";
import {connect} from 'react-redux'
import Form from "components/Form";
import ValidationShema from "constants/ValidationShema";
import {isDemandModification} from "libs/getDemandStatus";
import ModificationService from "services/ModificationService";
import Button from "components/Button";
import Tr from "translations/Translations";
import GridBlock from "components/GridBlock";
import RouterPath from "libs/RouterPath";
import NationalNoticeService from "services/NationalNoticeService";
import {DemandValidation, DemandValidationKeys} from "constants/DemandValidation";
import DemandValidationMessages from "components/DemandValidationMessages";
import {DemandValidationSectionStatus} from "constants/DemandValidationSectionStatus";
import {Typography} from "@material-ui/core";

function NationalNoticeSection(
    {
        match,
        demandValidation,
        demandHeader,
    }) {

    const demandId = match.params.id;
    const section = demandValidation.find(x => x.section === DemandValidation.NATIONAL_NOTICE);
    const editable = section ? section.editable : false;
    const handleSubmit = () => NationalNoticeService.saveContractNoticeSection(demandId)


    const reqSectionsError = useMemo(() => {
        const sections = [];
        sections.push(demandValidation.find(x => x.section === DemandValidation.SCHEDULE));
        if (!demandHeader.passiveOfferForm) {
            sections.push(demandValidation.find(x => x.section === DemandValidation.DEALINGS));
        }
        const errorSections = sections.filter(s => s.status !== DemandValidationSectionStatus.OK).map(s => Tr(DemandValidationKeys[s.section]));

        if (errorSections.length > 0) {
            return `${Tr("national_notice_sections_missing")}: '${errorSections.join("', '")}'`
        }
        return undefined;
    }, [demandValidation, demandHeader]);

    const handleClick = () => {
        const href = RouterPath.createPath(RouterPath.myProcedure.steps.MP_NATIONAL_NOTICE_FORM_TYPE_ID, {formType: "contractNotice", id: demandId});
        RouterPath.redirect(href);
    }

    return (<div style={{width: "100%"}}>
        {!!reqSectionsError && <Typography color="error">{reqSectionsError}</Typography>}
        <DemandValidationMessages section={section} editable={editable}/>
        <Form
            onSubmit={handleSubmit}
            id='mp_1_national_notice'
            validationSchema={ValidationShema.any()}
            afterSubmitFunc={() => {
                if (isDemandModification()) {
                    ModificationService.isDemandChanged(demandId);
                }
            }}
        >
            {(formikProps) => (<>
                    <GridBlock justify="center" alignItems="center">
                        <Button disabled={!!reqSectionsError}
                                onClick={handleClick}>{Tr("bzp_notice_create")}</Button>
                        <Typography><br/>{Tr("bzp_notice_create_info")}<br/><br/></Typography>
                        <br/><br/>
                    </GridBlock>
                </>
            )}
        </Form>
    </div>)
}

export default connect((state) => ({
    demandValidation: state.resources.demandValidation,
    demandHeader: state.resources.demandHeader
}), {})(withRouter(NationalNoticeSection));
